module.exports = __webpack_public_path__ + "img/02030209.ceb75d30.svg";